(function () {
  if (window.__registaCartToastLoaded) return;
  window.__registaCartToastLoaded = true;

  var lastToastAt = 0;
  var hideTimer = null;

  function getDiscountCode() {
    try {
      return window.sessionStorage.getItem('regista-look-discount-code') || '';
    } catch (error) {
      return '';
    }
  }

  function discountUrl(code, redirectPath) {
    if (!code) return redirectPath;
    return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirectPath);
  }

  function ensureToast() {
    var existing = document.querySelector('[data-regista-cart-toast]');
    if (existing) return existing;

    var toast = document.createElement('div');
    toast.className = 'regista-cart-toast';
    toast.setAttribute('data-regista-cart-toast', '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-hidden', 'true');
    toast.innerHTML = '' +
      '<div class="regista-cart-toast__inner">' +
        '<div class="regista-cart-toast__icon">✓</div>' +
        '<div>' +
          '<p class="regista-cart-toast__title">הפריט נוסף לעגלה</p>' +
          '<p class="regista-cart-toast__text">אפשר לבדוק את פרטי ההזמנה, המשלוח ואמצעי התשלום לפני החיוב.</p>' +
          '<div class="regista-cart-toast__proofs">' +
            '<span>✓ מספר מעקב</span>' +
            '<span>✓ אישור הזמנה במייל</span>' +
          '</div>' +
          '<div class="regista-cart-toast__actions">' +
            '<a class="regista-cart-toast__cart-link" href="/checkout">לקופה</a>' +
            '<a class="regista-cart-toast__view-cart" href="/cart">צפייה בעגלה</a>' +
          '</div>' +
        '</div>' +
        '<button class="regista-cart-toast__close" type="button" aria-label="סגירה">×</button>' +
      '</div>' +
      '<div class="regista-cart-toast__bar" aria-hidden="true"><span></span></div>';

    ['click', 'mousedown', 'mouseup', 'touchstart', 'touchend', 'pointerdown', 'pointerup'].forEach(function (eventName) {
      toast.addEventListener(eventName, function (event) {
        event.stopPropagation();
      }, true);
    });

    toast.querySelector('.regista-cart-toast__close').addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      hideToast(toast);
    });

    document.body.appendChild(toast);
    return toast;
  }

  function updateToastLinks(toast) {
    var code = getDiscountCode();
    var checkout = toast.querySelector('.regista-cart-toast__cart-link');
    var cart = toast.querySelector('.regista-cart-toast__view-cart');

    if (checkout) checkout.href = discountUrl(code, '/checkout');
    if (cart) cart.href = discountUrl(code, '/cart');
  }

  function hideToast(toast) {
    if (!toast) toast = document.querySelector('[data-regista-cart-toast]');
    if (!toast) return;

    toast.classList.remove('is-visible');
    toast.setAttribute('aria-hidden', 'true');

    if (hideTimer) {
      window.clearTimeout(hideTimer);
      hideTimer = null;
    }
  }

  function showToast() {
    var current = Date.now();
    if (current - lastToastAt < 650) return;
    lastToastAt = current;

    var toast = ensureToast();
    var progress = toast.querySelector('.regista-cart-toast__bar span');

    updateToastLinks(toast);

    if (progress) {
      progress.style.animation = 'none';
      progress.offsetHeight;
      progress.style.animation = '';
    }

    toast.style.pointerEvents = '';
    toast.removeAttribute('aria-hidden');

    window.requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    if (hideTimer) window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(function () {
      hideToast(toast);
    }, 8000);
  }

  function redirectWithDiscount(code, redirectPath) {
    if (!code) return false;
    window.location.href = discountUrl(code, redirectPath || '/cart');
    return true;
  }

  function routeCartWithDiscountIfNeeded(event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;

    var code = getDiscountCode();
    if (!code) return;

    var checkoutButton = target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
    if (checkoutButton) {
      event.preventDefault();
      redirectWithDiscount(code, '/checkout');
      return;
    }

    var link = target.closest('a[href]');
    if (!link) return;

    var href = link.getAttribute('href') || '';
    if (!/(^|\/)cart(\?|#|$)/.test(href)) return;

    event.preventDefault();
    redirectWithDiscount(code, '/cart');
  }

  function routeCheckoutSubmitWithDiscount(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart"]')) return;

    var code = getDiscountCode();
    if (!code) return;

    var submitter = event.submitter || document.activeElement;
    var isCheckout = submitter && submitter.name === 'checkout';
    if (!isCheckout) return;

    event.preventDefault();
    redirectWithDiscount(code, '/checkout');
  }

  document.documentElement.addEventListener('cart:change', function (event) {
    var detail = event.detail || {};
    if (detail.baseEvent === 'variant:add' || !detail.baseEvent) showToast();
  });

  document.addEventListener('click', routeCartWithDiscountIfNeeded, true);
  document.addEventListener('submit', routeCheckoutSubmitWithDiscount, true);

  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      var url = '';

      try {
        var firstArg = args[0];
        if (typeof firstArg === 'string') url = firstArg;
        else if (firstArg && firstArg.url) url = firstArg.url;
      } catch (error) {}

      var isCartAdd = /\/cart\/add(\.js)?/i.test(url);

      return originalFetch.apply(this, args).then(function (response) {
        if (isCartAdd && response && response.ok) {
          window.setTimeout(showToast, 80);
        }
        return response;
      });
    };
  }

  // Backward-compatible API for the bundle builder. It now shows an honest confirmation only.
  window.RegistaCartHold = {
    start: showToast,
    showToast: showToast
  };
})();
